// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"styles_textContainer__WrD2d"};